var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-screen flex w-full bg-img" }, [
    _c(
      "div",
      {
        staticClass:
          "vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
      },
      [
        _c("vx-card", [
          _c(
            "div",
            {
              staticClass: "full-page-bg-color",
              attrs: { slot: "no-body" },
              slot: "no-body"
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
                  },
                  [
                    _c("validation-observer", {
                      staticClass: "p-4",
                      attrs: { tag: "div" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var valid = ref.valid
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vx-logo flex justify-items-center items-center mb-2 pt-4"
                                },
                                [
                                  _c("img", {
                                    staticClass: "mx-auto",
                                    staticStyle: { "max-height": "25px" },
                                    attrs: {
                                      src: require("@/assets/images/logo/logo.png"),
                                      alt: "logo"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "vx-card__title mb-8" },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "mb-4 mt-4 grid justify-items-center"
                                    },
                                    [_vm._v("Recupere sua senha")]
                                  ),
                                  _c("p", [
                                    _vm._v(
                                      "Por favor informe seu endereço de email e iremos lhe enviar instruções pare alterar sua senha."
                                    )
                                  ])
                                ]
                              ),
                              _c("validation-provider", {
                                attrs: {
                                  name: "Email",
                                  rules: "required|email"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("vs-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|email",
                                                expression: "'required|email'"
                                              }
                                            ],
                                            staticClass: "w-full mb-8",
                                            attrs: {
                                              "data-vv-validate-on": "blur",
                                              type: "email",
                                              "label-placeholder": "Email"
                                            },
                                            model: {
                                              value: _vm.email,
                                              callback: function($$v) {
                                                _vm.email = $$v
                                              },
                                              expression: "email"
                                            }
                                          }),
                                          _c(
                                            "label",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-row gap-2 flex-wrap justify-center mt-4"
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: { disabled: !valid },
                                          on: {
                                            click: _vm.sendForgotInstruction
                                          }
                                        },
                                        [_vm._v("Recuperar Senha")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: {
                                            type: "border",
                                            to: "/login"
                                          }
                                        },
                                        [_vm._v("Voltar para Login")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }